import PrivateRoute from 'utils/privateRoute';
import ProductSuccessDashboard from "components/ProductSuccessObs/ProductSuccessDashboard";
import AboutPepWiseDashboard from "components/ProductSuccessObs/AboutPepWiseDashboard";

const ProductSuccessObsRoutes = [
    {
        key: 'product_success_dashboard_userAdoption',
        route: '/productSuccessDashboard/userAdoption',
        component: (
            <PrivateRoute
                Component={ProductSuccessDashboard}
                restrictedRoles={[]}
            />
        )
    },
    {
        key: 'product_success_dashboard_about_pepwise',
        route: '/productSuccessDashboard/aboutPepwise',
        component: (
            <PrivateRoute
                Component={AboutPepWiseDashboard}
                restrictedRoles={[]}
            />
        )
    }
]

export default ProductSuccessObsRoutes